module.exports = __webpack_public_path__ + "img/cambodia.471f7716.png";